<div class="cardLayout">
    <div class="d-flex flex-row justify-content-between align-items-center">
        <div class="d-flex flex-row align-items-center psic-gap-4">
            <h4>Policy Number</h4>
            <!-- <div [class.d-none]="!isLoading" class="spinner-border spinner-border-sm text-primary" role="status"></div> -->
            <app-animation
                [class.d-none]="!isLoading"
                [src]="'dots_loader.json'"
                [loop]="true"
                [autoplay]="true"
            ></app-animation>
        </div>
        <div [class.d-none]="isLoading" class="d-flex align-items-center psic-gap-3">
            <h6>{{ policyNumber }}</h6>
            <h6 class="policy-term-dropdown">
                <app-dynamic-form
                    [fields]="[policyTermField]"
                    [parentFormArray]="policyForm"
                    (formLoaded)="onFormLoaded($event)"
                ></app-dynamic-form>
            </h6>
        </div>
    </div>
</div>
